(() => {
  if (window.WaiiqiJourney) return;
  window.WaiiqiJourney = {
    create(count) {
      let index = 0;
      return {
        get index() { return index; },
        go(value) { index = Math.max(0, Math.min(count() - 1, value)); return index; },
        next() { return this.go(index + 1); },
        back() { return this.go(index - 1); },
        reset() { return this.go(0); },
        paint(bar) { bar.style.width = `${((index + 1) / count()) * 100}%`; }
      };
    },
    mark(button, value) {
      const icon = document.createElement('span');
      icon.className = 'wq-journey-icon';
      icon.setAttribute('aria-hidden', 'true');
      const colours = { ocean_blues: '#3f788b', earth_neutrals: '#b5a48b', black_monochrome: '#343740', bright_energy: '#dd775b' };
      if (colours[value]) { icon.style.background = colours[value]; icon.classList.add('wq-journey-swatch'); }
      else {
        const paths = {
          feminine: '<circle cx="12" cy="8" r="5"/><path d="M12 13v8m-4-4h8"/>',
          masculine: '<circle cx="9" cy="15" r="5"/><path d="m13 11 7-7m-6 0h6v6"/>',
          gender_neutral: '<circle cx="12" cy="7" r="3"/><path d="M6 21v-3a6 6 0 0 1 12 0v3"/>',
          surprise_me: '<path d="m12 3 2.5 6.5L21 12l-6.5 2.5L12 21l-2.5-6.5L3 12l6.5-2.5Z"/>',
          snug: '<circle cx="12" cy="12" r="4"/><circle cx="12" cy="12" r="6"/>',
          balanced: '<circle cx="12" cy="12" r="4"/><circle cx="12" cy="12" r="8"/>',
          relaxed: '<circle cx="12" cy="12" r="4"/><circle cx="12" cy="12" r="10"/>',
          xs: '<path d="M3 7h18v10H3Zm4 0v4m5-4v6m5-6v4"/>'
        };
        const drawing = paths[value] || (['s', 'm', 'l', 'xl'].includes(value) ? paths.xs : '<path d="M3 12c3-7 6-7 9 0s6 7 9 0"/>');
        icon.innerHTML = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" focusable="false">${drawing}</svg>`;
      }
      button.prepend(icon);
    }
  };
  window.dispatchEvent(new Event('waiiqi:journey-ready'));
})();
